<template>
  <div>
    <Head title="Devoluciones" />
    <h1 class="mb-8 text-3xl font-bold">Devoluciones</h1>
    <div class="flex items-center justify-between mb-6">
      <Link class="btn-blue" href="/devolutions/create">
        <span>Crear</span>
        <span class="hidden md:inline">&nbsp;Devolución</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Orden</th>
          <th class="pb-4 pt-6 px-6">Fecha</th>
          <th class="pb-4 pt-6 px-6">Tipo</th>
          <th class="pb-4 pt-6 px-6">Monto</th>
          <th class="pb-4 pt-6 px-6">Estado</th>
          <th class="pb-4 pt-6 px-6">Acciones</th>
        </tr>
        <tr v-for="devolution in devolutions.data" :key="devolution.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link :href="`/devolutions/${devolution.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              #{{ devolution.order.number_order }}
            </Link>
          </td>
          <td class="border-t">
            <Link :href="`/devolutions/${devolution.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ getDate(devolution.created_at) }}
            </Link>
          </td>
          <td class="border-t">
            <Link :href="`/devolutions/${devolution.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ devolution.return_type === 'partial' ? 'Parcial' : 'Completa' }}
            </Link>
          </td>
          <td class="border-t">
            <Link :href="`/devolutions/${devolution.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ formatCurrency(devolution.total_amount) }}
            </Link>
          </td>
          <td class="border-t">
            <Link :href="`/devolutions/${devolution.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              <span :class="getStatusClass(devolution.status)">
                {{ getStatusText(devolution.status) }}
              </span>
            </Link>
          </td>
          <td class="border-t">
            <div class="flex items-center px-6 py-4">
              <Link :href="`/devolutions/${devolution.id}`" class="text-indigo-600 hover:text-indigo-900 mr-4">
                Ver
              </Link>
              <button v-if="devolution.status === 'pending'" 
                      @click="approveDevolution(devolution.id)"
                      class="text-green-600 hover:text-green-900">
                Aprobar
              </button>
            </div>
          </td>
        </tr>
        <tr v-if="!devolutions.length">
          <td class="px-6 py-4 border-t" colspan="6">No hay devoluciones registradas.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="devolutions.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Link,
    Pagination,
  },
  layout: Layout,
  props: {
    devolutions: Object,
  },
  methods: {
    getDate(date) {
      return new Date(date).toLocaleString('es-VE', { hour12: false })
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat('es-VE', {
        style: 'currency',
        currency: 'VES'
      }).format(amount)
    },
    getStatusClass(status) {
      return {
        'pending': 'text-yellow-600',
        'approved': 'text-green-600',
        'rejected': 'text-red-600'
      }[status]
    },
    getStatusText(status) {
      return {
        'pending': 'Pendiente',
        'approved': 'Aprobada',
        'rejected': 'Rechazada'
      }[status]
    },
    approveDevolution(id) {
      if (confirm('¿Está seguro de aprobar esta devolución?')) {
        this.$inertia.post(`/devolutions/${id}/approve`)
      }
    }
  }
}
</script>
